import { Component, Input } from '@angular/core';

import { IOrderQueryParams } from '@interfaces/params.interface';

@Component({
  selector: 'app-sort-arrow-direction',
  templateUrl: './sort-arrow-direction.component.html',
})
export class SortArrowDirectionComponent {
  @Input() queryParams: IOrderQueryParams = {};
  @Input() queryParamName: string;
}
